<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-building"></span>Stores</div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </div>
  <div class="content">


    <!--<div class="row margin-top-16">
        <div pTooltip="Create a new cyclist" tooltipPosition="left" class="fa fa-partner-plus font-button pull-right"
          style="margin-left: auto!important;margin-right: 16px!important;" (click)="addpartner()"></div>
      </div>-->
    <div class="margin-top-16">
      <p-table #partnersTable [columns]="columns" [value]="partners" [rows]="limit">
        <ng-template pTemplate="caption">
          <!--<div style="text-align: left">
            <p-radioButton name="groupname" value=""   label="All" [(ngModel)]="status" (onClick)="filterList()"></p-radioButton>
            <p-radioButton name="groupname" value="1"   label="Trial In Progress" [(ngModel)]="status" (onClick)="filterList()"></p-radioButton>
            <p-radioButton name="groupname" value="2"   label="Trial Expired" [(ngModel)]="status" (onClick)="filterList()"></p-radioButton>
            <p-radioButton name="groupname" value="3"   label="Payment Missed" [(ngModel)]="status" (onClick)="filterList()"></p-radioButton>
            <p-radioButton name="groupname" value="4"   label="Payment Method Expired" [(ngModel)]="status" (onClick)="filterList()"></p-radioButton>
            <p-radioButton name="groupname" value="20"  label="Cancellation In Progress" [(ngModel)]="status" (onClick)="filterList()"></p-radioButton>
            <p-radioButton name="groupname" value="21"  label="Cancelled" [(ngModel)]="status" (onClick)="filterList()"></p-radioButton>
            <p-radioButton name="groupname" value="50"  label="Active" [(ngModel)]="status" (onClick)="filterList()"></p-radioButton>
          </div>-->
          <div class="row  justify-content-start mb-2">
            <div class="col-3 d-flex">
              <input type="text" pInputText size="50" placeholder="Search" [(ngModel)]="search"
                     (input)="searchPartners()" style="width:auto">
              <i class="fa fa-search mt-2" style="margin-left: -30px"></i>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns"
              [ngStyle]="{'width' : col.width || 'auto'}">
              {{col.header}}
              <!-- <p-sortIcon [field]="col.field" style="vertical-align: middle;" *ngIf="col.type !== 'action'">
              </p-sortIcon> -->
            </th>
            <!-- <th style="width: 255px;">Actions</th> -->
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-partner let-columns="columns">
          <tr [pSelectableRow]="partner">
            <td *ngFor="let col of columns">
              <div *ngIf="col.type!=='actions'" (click)="impersonate(partner)" [ngClass]="{
                'demo': col.type === 'status' && getStatus(partner[col.field], partner['trialEnds']) === 'Demo Account',
                'active': col.type === 'status' && getStatus(partner[col.field], partner['trialEnds']) === 'Active',
                'trial': col.type === 'status' && getStatus(partner[col.field], partner['trialEnds']).indexOf('Trial')>-1,
                'expired': col.type === 'status' && getStatus(partner[col.field], partner['trialEnds']).indexOf('Expired')>-1,
                'missed': col.type === 'status' && getStatus(partner[col.field], partner['trialEnds']).indexOf('Missed')>-1,
                'cancelled': col.type === 'status' && getStatus(partner[col.field], partner['trialEnds']).indexOf('Cancel')>-1}">
                {{
                col.type==='boolean' ? (partner[col.field] ? "Yes" : "No") :
                col.type==='posSystemID' ? getPOSSystem(partner[col.field]) :
                col.type==='status' ? getStatus(partner[col.field], partner['trialEnds']) :
                col.type==='productsSyncd' && partner[col.field] ? partner[col.field] + (partner['posProductCount'] ? '
                ('+partner['posProductCount'] +')' : '') :
                col.type==='clientsSyncd' && partner[col.field] ? partner[col.field] + (partner['posClientCount'] ? '
                ('+partner['posClientCount'] +')' : '') :
                partner[col.field]
                }}
              </div>
              <div *ngIf="col.type === 'actions'" style="text-align:left;display: flex;">
                <span class="fa fa-cc-stripe" pTooltip="Edit Subscription Statuses"  (click)="editStoreSubscription(partner)"></span>
                <span class="fa fa-calendar-o" pTooltip="Extend Trial"  (click)="showTrialExtendPopup(partner)" *ngIf="partner['statusID'] === 1 || partner['statusID'] === 2"></span>
                <span class="fa fa-comments-o" pTooltip="Add SMS Credits" (click)="showSMSPopup(partner)" *ngIf="allowAddSMS(partner)"></span>
                <span class="fa fa-user-o" pTooltip="Resync Customers" (click)="initiateFullClientResync(partner)" *ngIf="allowClientSync(partner)"></span>
                <span class="fa fa-refresh" pTooltip="Resync POS Products" (click)="initiateFullPOSResync(partner)" *ngIf="allowProductSync(partner)"></span>
                <!-- <span class="fa fa-sign-in" pTooltip="Impersonate Shop" (click)="impersonate(partner)"></span> -->
              </div>
            </td>
            <!-- <td style="text-align:left;">

              <button pButton label="Initiate Full Product Sync" (click)="initiateFullResync(partner)"
                class="p-button-raised full-width icon alternate" icon="pi pi-spin pi-spinner" iconPos="right"
                *ngIf="[3,6,8,4,9].includes(partner.posSystemID)" [disabled]="partner.syncBusy"></button>
            </td> -->
            <!-- <td style="text-align:left;display: flex;">
              <span class="fa fa-calendar-o" pTooltip="Extend Trial"  (click)="showTrialExtendPopup(partner)" *ngIf="partner['statusID'] === 1 || partner['statusID'] === 2"></span>
              <span class="fa fa-comments-o" pTooltip="Add SMS Credits" (click)="showSMSPopup(partner)" *ngIf="allowAddSMS(partner)"></span>
              <span class="fa fa-user-o" pTooltip="Resync Customers" (click)="initiateFullClientResync(partner)" *ngIf="allowClientSync(partner)"></span>
              <span class="fa fa-refresh" pTooltip="Resync POS Products" (click)="initiateFullPOSResync(partner)" *ngIf="allowProductSync(partner)"></span>
              <span class="fa fa-sign-in" pTooltip="Impersonate Shop" (click)="impersonate(partner)"></span>
              <button pButton label="Impersonate Shop" class="p-button-raised full-width"
                (click)="impersonate(partner)"></button>
            </td> -->
          </tr>
        </ng-template>
      </p-table>
      <p-paginator #paginator [rows]="limit" [totalRecords]="totalRecords" (onPageChange)="paginate($event)"></p-paginator>
    </div>

  </div>
</div>
<p-confirmDialog></p-confirmDialog>

<p-dialog [(visible)]="showSMS" [style]="{width: '400px'}" [modal]="true" header="Add SMS Credits">
  <div class="row margin-top-8">
    <div class="col-md-8 label">Enter the number of SMS's to allocate:</div>
    <div class="col-md-4">
      <div class="p-inputgroup">
        <input type="number" pInputText [(ngModel)]="SMSCredits" />
      </div>
    </div>
  </div>
  <p-footer>
    <button pButton label="Add Credits" class="p-button-raised full-width" (click)="addSMSCredits()" [disabled]="SMSCredits === ''"></button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="showTrial" [style]="{width: '500px'}" [modal]="true" header="Extend Trial">
  <div class="row margin-top-8">
    <div class="col-md-12 label">Set the end date of the new trial end date:</div>
    <div class="col-md-12">
      <div class="p-inputgroup">
        <p-calendar [(ngModel)]="trialEndDate" [inline]="true"></p-calendar>
      </div>
    </div>
  </div>
  <p-footer>
    <button pButton label="Extend Trial" class="p-button-raised full-width" (click)="updateTrailPeriod()" [disabled]="trialEndDate === null"></button>
  </p-footer>
</p-dialog>


<p-sidebar #NavSideBar3 [(visible)]="showEditStoreSubscription" position="right"
  [style]="{width:'70em', background: '#F6F6F8', 'overflow-x': 'auto'}" (onHide)="getPartners(); NavSideBar3.destroyModal()">
  <div *ngIf="showEditStoreSubscription">
    <app-edit-store-subscription [partner]="selectedPartner"></app-edit-store-subscription>
  </div>
</p-sidebar>